const initImagesComparison = () => {
	const imagesComponent = document.querySelectorAll( 'section.images-comparison' );

	if ( !imagesComponent.length )
	{
		return;
	}

	imagesComponent.forEach( ( component ) => {
		let x = null;
		x = component.getElementsByClassName( 'img-comp-overlay' );

		const compareImages = ( img ) => {
			let slider = null;
			let clicked = 0;
			let w = null;
			let h = null;
			
			w = img.offsetWidth;
			h = img.offsetHeight;

			img.style.width = `${( w / 2 )}px`;

			window.addEventListener( 'resize', () => {
				w = img.querySelector( 'img' ).offsetWidth;
			} );
			
			const sliderTemplate = `
				<div class="slider">
					<svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M56 28C56 51.058 51.058 56 28 56C4.94199 56 -1.48267e-05 51.058 -1.2811e-05 28C-1.07952e-05 4.942 4.94199 -4.46363e-06 28 -2.44784e-06C51.058 -4.32044e-07 56 4.942 56 28Z" fill="white"/>
						<rect x="26" width="4" height="56" fill="#010620"/>
						<path d="M14.9133 31.9784C14.89 31.9926 14.8643 32 14.8381 32C14.8055 31.9999 14.7736 31.9882 14.7467 31.9664L10.0697 28.1599C10.0261 28.1243 10 28.0657 10 28.0031C10 27.9404 10.0261 27.8818 10.0697 27.8462L14.7467 24.0334C14.7965 23.9931 14.8612 23.9889 14.9145 24.0226C14.9677 24.0563 15.0007 24.1221 15 24.1934L15 31.8096C15 31.8805 14.9666 31.9456 14.9133 31.9784Z" fill="#010620"/>
						<path d="M41.0867 24.0216C41.11 24.0074 41.1357 24 41.1619 24C41.1945 24.0001 41.2264 24.0118 41.2533 24.0336L45.9303 27.8401C45.9739 27.8757 46 27.9343 46 27.9969C46 28.0596 45.9739 28.1182 45.9303 28.1538L41.2533 31.9666C41.2035 32.0069 41.1388 32.0111 41.0855 31.9774C41.0323 31.9437 40.9993 31.8779 41 31.8066L41 24.1904C41 24.1195 41.0334 24.0544 41.0867 24.0216Z" fill="#010620"/>
					</svg>
				</div>
			`;

			img.parentElement.insertAdjacentHTML( 'afterBegin', sliderTemplate );
			
			slider = component.querySelector( 'div.slider' );

			slider.style.top = `${( h / 2 ) - ( slider.offsetHeight / 2 )}px`;
			slider.style.left = `${( w / 2 ) - ( slider.offsetWidth / 2 )}px`;

			const slideReady = ( e ) => {
				e.preventDefault();
				clicked = 1;

				window.addEventListener( 'mousemove', slideMove );
				window.addEventListener( 'touchmove', slideMove );
			};

			const slideFinish = () => {
				clicked = 0;
			};
			
			slider.addEventListener( 'mousedown', slideReady );
			window.addEventListener( 'mouseup', slideFinish );
			slider.addEventListener( 'touchstart', slideReady );
			window.addEventListener( 'touchstop', slideFinish );

			const slideMove = ( e ) => {
				let pos = null;

				if ( clicked === 0 )
				{
					return false;
				}

				pos = getCursorPos( e );

				if ( pos < 0 )
				{
					pos = 0;
				}

				if ( pos > w )
				{
					pos = w;
				}

				slide( pos );
			};

			const getCursorPos = ( e ) => {
				let a = null;
				let t = 0;

				e = e || window.event;

				a = img.getBoundingClientRect();

				t = e.pageX - a.left;

				t = t - window.pageXOffset;

				return t;
			};

			const slide = ( b ) => {
				img.style.width = `${b}px`;
				slider.style.left = `${img.offsetWidth - ( slider.offsetWidth / 2 )}px`;
			};
		};

		for ( let i = 0; i < x.length; i++ ) {
			compareImages( x[i] );
		}
	} );
};

export {
	initImagesComparison,
};
